// src/directives/index.js 【弃用】
import { noSpecialCharsDirective } from './noSpecialChars'

// 导出所有指令
export const directives = {
  noSpecialChars: noSpecialCharsDirective
}

// 默认导出，便于全局注册
export default {
  install(app) {
    // 注册特殊字符过滤指令
    app.directive('no-special-chars', noSpecialCharsDirective)

    // 可以在这里注册其他指令
    // app.directive('other-directive', otherDirective)
  }
}
